import React, { useEffect, useState } from 'react'
import Footer from '../../CoreComponents/Footer';
import Header from '../../CoreComponents/Header';
import MainHeader from '../../CoreComponents/MainHeader';
import NavBar from '../../CoreComponents/NavBar';
import { ManagePassword, ManageProfile } from './Logic';
import { is_superuser, url, is_shop_admin, is_franchise_admin, is_franchise_manager, is_franchise_staff } from "../../Functionalities/Config";
import image from "../../Assets/images/profile_icon.jpg";
import { Logout, showMessage } from '../../Functionalities/Functions';
import EditTopComponent from '../../CoreComponents/EditTopComponent'
import { validateEmail } from '../../Functionalities/Validation';
function Body() {
    const [editPassword, setEditPassword] = useState(false)
    const [password, setPassword] = useState({
        id: "",
        username: "",
        password: "",
        new_password: "",
        confirm_password: ''
    })
    const [errors, setErrors] = useState([])
    const [data, setData] = useState({})
    const [superData, setSuperData] = useState({
        username: "",
        new_username: "",
        password: "",
        new_password: "",
        confirm_password: "",
        keyword: "super"
    })
    const [formData, setFormData] = useState({
        id: "",
        name: "",
        email: "",
        mobile: "",
        username: "",
        address1: "",
        latitude: "",
        longitude: ""
    })
    useEffect(() => {
        fetchData()
        if (errors.length > 0) {
            showMessage(errors[0], "danger", " Following fields are required!", "top", "top-right", 0)
        }


    }, [errors])
    const fetchData = () => {
        let result = ManageProfile('', '', 'get', '')
        result.then((result) => {
            setData(result.data.results[0])
            setFormData({
                ...formData,
                id: result.data.results[0].id,
                name: result.data.results[0].first_name,
                email: result.data.results[0].email,
                mobile: result.data.results[0].details ? result.data.results[0].details.mobile : 0,
                username: result.data.results[0].username,
                address1: result.data.results[0].address.length > 0 ? result.data.results[0].address[0].address1 : "",
                latitude: result.data.results[0].address.length > 0 ? result.data.results[0].address[0].latitude : "",
                longitude: result.data.results[0].address.length > 0 ? result.data.results[0].address[0].longitude : ""
            })
            setPassword({ ...password, username: result.data.results[0].username, id: result.data.results[0].id, })
            setSuperData({ ...superData, username: result.data.results[0].username, })
        })
    }
    return (
        <div className="content-body">
            <div className="container-fluid">
               
                  <EditTopComponent
          />
                
                <div className="row">
                    <div className="col-lg-12">
                        <div className="profile card card-body px-3 pt-3 pb-0">
                            <div className="profile-head">
                                <div className="photo-content">
                                </div>
                                <div className="profile-info">
                                    <div className="profile-photo">
                                        {
                                            (data.images != null && data.images === true) ? (
                                                <img className="img-fluid rounded-circle"
                                                    src={
                                                        url + data.images
                                                    }

                                                    alt="Foodoor" />
                                            ) : (
                                                    <img className="img-fluid rounded-circle"
                                                        src={image}

                                                        alt="Foodoor" />
                                                )
                                        }
                                    </div>
                                    <div className="profile-details">
                                        <div className="profile-name px-3 pt-2">
                                            <p>Name</p>
                                            <h4 className="text-primary mb-0">
                                                {
                                                    data.first_name ? data.first_name : "Customer Name"
                                                }
                                            </h4>

                                        </div>
                                        {data.email && <div className="profile-email px-2 pt-2">
                                            <p>Email</p>
                                            <h4 className="text-muted mb-0">
                                                {data.email ? data.email : "No Email"}
                                            </h4>

                                        </div>}
                                       {data.address && data.address.length > 0 && <div className="profile-email px-2 pt-2">
                                            <p>Address</p>
                                            <h4 className="text-muted mb-0">
                                                {
                                                    data.address && data.address.length > 0 && data.address[0].address1
                                                }
                                            </h4>

                                        </div>}
                                        <div className="profile-email px-2 pt-2">
                                            <p>Phone</p>
                                            <h4 className="text-muted mb-0">
                                                {
                                                    data.details ? data.details.mobile : "No number"
                                                }
                                            </h4>

                                        </div>
                                    </div>
                                </div>
                            </div></div></div></div>

                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body">
                                <div className="post-details">
                                    <div class="card-header">
                                        <h4 class="card-title">Edit Profile</h4>
                                        {(!is_superuser && !editPassword) && <span><button type="submit" class="btn btn-primary mr-1" onClick={(e) => { setEditPassword(true) }} role="button">Edit Password</button></span>}
                                    </div>
                                    {(!is_superuser && editPassword) && <div className="row">
                                        {/* <div className="col-xl-6 col-lg-12 text-right"></div> */}
                                        <div className="col-xl-12 col-lg-12  text-right">

                                            <div className="card">
                                                <div className="card-header">
                                                    <h4 className="card-title">Edit Password</h4>
                                                </div>
                                                <div className="card-body">
                                                    <div className="basic-form">
                                                        <form>
                                                            <div className="form-row text-left">


                                                                <div className="form-group col-md-4">
                                                                    <label>Old-Password</label>
                                                                    <input type="password" className="form-control" placeholder="Password"
                                                                        value={password.password} onChange={
                                                                            (e) => {
                                                                                setPassword({ ...password, password: e.target.value })
                                                                            }
                                                                        }
                                                                    />
                                                                </div>
                                                                <div className="form-group col-md-4">
                                                                    <label>New-Password</label>
                                                                    <input type="password" className="form-control" placeholder="New_Password"
                                                                        value={password.new_password} onChange={
                                                                            (e) => {
                                                                                setPassword({ ...password, new_password: e.target.value })
                                                                            }
                                                                        }
                                                                    />
                                                                </div>
                                                                <div className="form-group col-md-4">
                                                                    <label>Confirm-Password</label>
                                                                    <input type="password" className="form-control" placeholder="New_Password"
                                                                        value={password.confirm_password} onChange={
                                                                            (e) => {
                                                                                setPassword({ ...password, confirm_password: e.target.value })
                                                                            }
                                                                        }
                                                                    />
                                                                </div>

                                                            </div>

                                                            <button type="submit" className="btn btn-primary mr-2" onClick={(e) => { setEditPassword(false) }}>Cancel</button>
                                                            <button type="submit" className="btn btn-primary" onClick={
                                                                (e) => {
                                                                    e.preventDefault()
                                                                    setErrors([])
                                                                    if (password.password === "") {
                                                                        setErrors(["password"])
                                                                        return
                                                                    }
                                                                    if (password.new_password === "") {
                                                                        setErrors(["new password"])
                                                                        return
                                                                    }
                                                                    if (password.new_password != password.confirm_password) {
                                                                        setErrors(["Passwords do not match"])
                                                                        return
                                                                    }

                                                                    let result = ManagePassword(e, password, 'patch', '')
                                                                    result.then(result => {
                                                                        if (result.data.Status === true) {
                                                                            showMessage("Password changed successfully", "success", "Success!", "top", "top-right", 0)
                                                                            setEditPassword(false)
                                                                            setPassword({
                                                                                password: "",
                                                                                new_password: ""
                                                                            })
                                                                            Logout();
                                                                            window.location.replace("/login");
                                                                        }
                                                                        else {

                                                                            showMessage(result.data.Error, "danger", "Failed!", "top", "top-right", 0)
                                                                        }
                                                                    })
                                                                }
                                                            }
                                                            >Submit</button>
                                                        </form>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>}
                                    {/* {( is_franchise_admin || is_franchise_manager || is_franchise_staff) && */}
                                    {is_superuser &&
                                        <div className="card-body">
                                            <div className="basic-form">
                                                <form>
                                                    <div className="form-group row">
                                                        <label className="col-sm-3 col-form-label">Old Username<span class="required">*</span> :</label>
                                                        <div className="col-sm-9">
                                                            <input type="text" className="form-control" value={superData.username} onChange={(e) => { setSuperData({ ...superData, username: e.target.value }) }} />
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <label className="col-sm-3 col-form-label">New Username<span class="required">*</span> :</label>
                                                        <div className="col-sm-9">
                                                            <input type="text" className="form-control" value={superData.new_username} onChange={(e) => { setSuperData({ ...superData, new_username: e.target.value }) }} />
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <label className="col-sm-3 col-form-label">Old Password<span class="required">*</span> :</label>
                                                        <div className="col-sm-9">
                                                            <input type="text" className="form-control" value={superData.password} onChange={(e) => { setSuperData({ ...superData, password: e.target.value }) }} />
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <label className="col-sm-3 col-form-label">New Password<span class="required">*</span> :</label>
                                                        <div className="col-sm-9">
                                                            <input type="text" className="form-control" value={superData.new_password} onChange={(e) => { setSuperData({ ...superData, new_password: e.target.value }) }} />
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <label className="col-sm-3 col-form-label">Confirm Password<span class="required">*</span> :</label>
                                                        <div className="col-sm-9">
                                                            <input type="text" className="form-control" value={superData.confirm_password} onChange={(e) => { setSuperData({ ...superData, confirm_password: e.target.value }) }} />
                                                        </div>
                                                    </div>
                                                    
                                                    <div className="form-group row text-right">
                                                        <div className="col-sm-12">
                                                            <button
                                                                type="submit"
                                                                className="btn btn-primary"
                                                                onClick={
                                                                    (e) => {
                                                                        e.preventDefault()
                                                                        // alert('helo')
                                                                        setErrors([])
                                                                        if (superData.username === "") {
                                                                            setErrors(["old username"])
                                                                            return
                                                                        }
                                                                        if (superData.new_username === "") {
                                                                            setErrors(["new username"])
                                                                            return
                                                                        }
                                                                        if (superData.password === "") {
                                                                            setErrors(["old password"])
                                                                            return
                                                                        }
                                                                        if (superData.new_password === "") {
                                                                            setErrors(["old password"])
                                                                            return
                                                                        }
                                                                        if (superData.new_password != superData.confirm_password) {
                                                                            setErrors(["Passwords do not match"])
                                                                            return
                                                                        }
                                                                        let result = ManageProfile(e, superData, "update", "")
                                                                        result.then(result => {
                                                                            if (result.data.Status === true) {
                                                                                showMessage("superuser username and password updated successfully", "success", "Success!", "top", "top-right", 0)
                                                                                Logout();
                                                                                window.location.replace("/login");
                                                                            }
                                                                            else {
                                                                                showMessage(result.data.Error, "danger", "Failed!", "top", "top-right", 0)
                                                                            }
                                                                        })
                                                                    }
                                                                }
                                                            > Save
                        </button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    }
                                    {!is_superuser &&
                                        <div className="card-body">
                                            <div className="basic-form">

                                                <form>

                                                    <div className="form-group row">
                                                        <label className="col-sm-3 col-form-label">First name<span class="required">*</span> :{" "}</label>
                                                        <div className="col-sm-9">
                                                            <input type="text" className="form-control" value={formData.name} onChange={(e) => { setFormData({ ...formData, name: e.target.value }) }}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div className="form-group row">
                                                        <label className="col-sm-3 col-form-label">Username<span class="required">*</span> :</label>
                                                        <div className="col-sm-9">
                                                            <input type="text" className="form-control" value={formData.username} onChange={(e) => { setFormData({ ...formData, username: e.target.value }) }} />
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <label className="col-sm-3 col-form-label">Email
                                                            {/* <span class="required">*</span> :{" "} */}
                                                        </label>
                                                        <div className="col-sm-9">
                                                            <input type="email" className="form-control" value={formData.email} onChange={(e) => { setFormData({ ...formData, email: e.target.value }) }} />
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <label className="col-sm-3 col-form-label">Mobile<span class="required">*</span> :{" "}</label>
                                                        <div className="col-sm-9">
                                                            <input type="number" onKeyDown={(evt) => (evt.key === 'e' || evt.key === '-') && evt.preventDefault() || evt.key === 'E' && evt.preventDefault()}
                                                                onWheelCapture={e => {
                                                                    e.target.blur()
                                                                }} className="form-control" value={formData.mobile} onChange={(e) => { setFormData({ ...formData, mobile: e.target.value.slice(0, 10) }) }} />
                                                        </div>
                                                    </div>
                                                    {/* <div className="form-group row">
                                                        <label className="col-sm-3 col-form-label">Address<span class="required">*</span> :{" "}</label>
                                                        <div className="col-sm-9">
                                                            <input type="text" className="form-control" value={formData.address1} onChange={(e) => { setFormData({ ...formData, address1: e.target.value }) }} />
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <label className="col-sm-3 col-form-label">Latitude<span class="required">*</span> :{" "}</label>
                                                        <div className="col-sm-9">
                                                            <input type="number" onKeyDown={(evt) => (evt.key === 'e' || evt.key === '-') && evt.preventDefault() || evt.key === 'E' && evt.preventDefault()}
                                                                onWheelCapture={e => {
                                                                    e.target.blur()
                                                                }} className="form-control" value={formData.latitude} onChange={(e) => { setFormData({ ...formData, latitude: e.target.value }) }} />
                                                        </div>
                                                    </div>
                                                    <div className="form-group row">
                                                        <label className="col-sm-3 col-form-label">Longitude<span class="required">*</span> :{" "}</label>
                                                        <div className="col-sm-9">
                                                            <input type="number" onKeyDown={(evt) => (evt.key === 'e' || evt.key === '-') && evt.preventDefault() || evt.key === 'E' && evt.preventDefault()}
                                                                onWheelCapture={e => {
                                                                    e.target.blur()
                                                                }} className="form-control" value={formData.longitude} onChange={(e) => { setFormData({ ...formData, longitude: e.target.value }) }} />
                                                        </div>
                                                    </div> */}
                                                    <div className="form-group row text-right">
                                                        <div className="col-sm-12">
                                                            <button
                                                                type="submit"
                                                                className="btn btn-primary"
                                                                onClick={
                                                                    (e) => {
                                                                        e.preventDefault()

                                                                        setErrors([])
                                                                        if (formData.name === "") {
                                                                            setErrors(["first name"])
                                                                            return
                                                                        }
                                                                        if (formData.username === "") {
                                                                            setErrors(["username"])
                                                                            return
                                                                        }
                                                                        // if (formData.email === "") {
                                                                        //     setErrors(["email"])
                                                                        //     return
                                                                        // }
                                                                        if(formData.email){
                                                                            if(!validateEmail(formData.email)){
                                                                                setErrors(["Invalid email"])
                                                                                return
                                                                            }
                                                                        }
                                                                        if (formData.mobile === "") {
                                                                            setErrors(["mobile"])
                                                                            return
                                                                        }
                                                                        if(formData.mobile.length != 10){
                                                                                setErrors(["mobile number not valid"])
                                                                                return
                                                                             
                                                                        }
                                                                        // if (formData.address1 === "") {
                                                                        //     setErrors(["address"])
                                                                        //     return
                                                                        // }
                                                                        // if (formData.latitude === "") {
                                                                        //     setErrors(["latitude"])
                                                                        //     return
                                                                        // }
                                                                        // if (formData.longitude === "") {
                                                                        //     setErrors(["longitude"])
                                                                        //     return
                                                                        // }
                                                                        let result = ManageProfile(e, formData, "update", "")
                                                                        result.then(result => {
                                                                            if (result.data.Status === true) {
                                                                                showMessage("Profile details updated successfully", "success", "Success!", "top", "top-right", 0)
                                                                            }
                                                                            else {

                                                                                showMessage(result.data.Error, "danger", "Failed!", "top", "top-right", 0)
                                                                            }
                                                                        })
                                                                    }
                                                                }
                                                            > Save
                        </button>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>}

                                </div>
                            </div></div></div></div>


            </div>
        </div>
    )
}

function Profile() {
    const header = "Profile";
    return (
        <div>
            <div id="main-wrapper">
                <MainHeader />
                <Header name={header} />
                <NavBar />
                <Body />
                <Footer />
            </div>
        </div>
    );
}

export default Profile
